import MyPopup from "../MyPopup";
import fontOptions from "../../../utils/core";
import Icon from "../Icon";

interface FontSelectProps {
  value?: string;
  onChange: (value: string) => void;
}

export default function FontSelect({
  value = "sans-serif",
  onChange,
}: FontSelectProps) {
  const selectedOption = fontOptions?.find((o) => o.value === value);
  const displayLabel =
    selectedOption?.label || (value === "serif" ? "Serif" : "Sans Serif");

  return (
    <div>
      <MyPopup
        trigger={
          <button className="font-option heading">
            {displayLabel}
            <Icon name="DownArrow" />
          </button>
        }
      >
        {({ close }) => (
          <div className="p-4 mail-inbox-popup-content">
            <div className="font-options">
              {fontOptions.map((font) => (
                <button
                  className="btn-mail-editor"
                  key={font.value}
                  onClick={() => {
                    onChange(font.value);
                    close();
                  }}
                  style={{ ...font.style }}
                >
                  <div className="font-option">
                    {value === font.value && <Icon name="Check" />}
                    {font.label}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
      </MyPopup>
    </div>
  );
}
